// These options should have been defined on the backend...
export const COMPANION_TITLES: Array<App.Title> = ['Mr', 'Mrs', 'Miss', 'Ms', 'Master', 'Dr']
export const COMPANION_RELATIONSHIPS = [
  ['partner/spouse', 'Partner/Spouse'],
  ['family', 'Family'],
  ['child', 'Child'],
  ['friend', 'Friend'],
  ['other', 'Other'],
] as const

export const companionsLabelMap = Object.fromEntries(COMPANION_RELATIONSHIPS)
